import Controller, { OnBeforeFetch, OnChange, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { HttpService, MessageService, } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../constants/endpoints';
import BaseController from '../BaseController';
import { ChangeEvent, FetchEvent, SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import InformationBarUtils from '../commons/header/information-bar-header-utils';
import { FoundationUtils } from '../../utils/foundation-utils';
import { FragmentNames, StartEndAdmChemoAliases } from '../../codegen';
import { AutocompleteAPI, BaseModalProps, ButtonAPI, ContextualBarAPI, FetchAPI, InputAPI, ModalButton, ModalService, ToastService } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import { CHEMO_E3130Parameters, FunctionName } from '../../utils/parameters';
import { ModalButtonType, ModalType, Placement, ToastLevel } from '@philips-internal/oswald-ui-constants';
import moment, { Moment } from 'moment';

interface RetornoProc {
  dsAlerta: string;
  dsErro: string;
  dsMsg: string;
  dsPergunta: string;
}

interface AutoCompAcomodation {
  cdAcomodacao: string;
  dsAcomodacao: string;
}

enum ValueParams {
  YES = 'S',
  NO = 'N',
  ALERT = 'A'
}

interface InformationProtocol {
  body: {
    cdLocal: number;
    dsErro: string;
    dsLocal: string;
    dsMsgAlerta: string;
    dsQuestion: string;
    dsTitle: string;
    dsTypeEncount: string;
    dtArrived: string;
    dtDischarge: string;
    dtEndAdm: string;
    dtPrev: string;
    dtReal: string;
    dtRelease: string;
    dtStartAdm: string;
    ieEnconterDisp: string;
    ieOrdemDisp: string;
    ieQtCheck: number;
    ieReleaseDemands: string;
    ieTypeEnconter: number;
    nrPatient: number;
    nrPrescrEncount: string;
    nrPrescription: number;
    nrSeqScheduler: number;
    param123: string;
  }
}

@Controller({ fragment: FragmentNames.START_END_ADM_CHEMO })
class StartEndAdmChemoController extends BaseController {

  private information: InformationProtocol | null = null;
  @Inject(StartEndAdmChemoAliases.DATE_HOUR_ARRIVED_INPUT)
  private inputArrived!: InputAPI;
  @Inject(StartEndAdmChemoAliases.DATE_HOUR_END_ADM_INPUT)
  private inputEnd!: InputAPI;
  @Inject(StartEndAdmChemoAliases.DATE_HOUR_START_ADM_INPUT)
  private inputStart!: InputAPI;
  @Inject(StartEndAdmChemoAliases.ACOMODATION_AUTOCOMPLETE)
  private autoCompleteAcomodation!: AutocompleteAPI;
  @Inject(StartEndAdmChemoAliases.BUTTON_ARRIVED_INFORMATION)
  private bntArrivedInf!: ButtonAPI;
  @Inject(StartEndAdmChemoAliases.BUTTON_ARRIVE_REMOVE)
  private bntArrivedRem!: ButtonAPI;
  @Inject(StartEndAdmChemoAliases.BUTTON_STARTADM_INFORMATION)
  private bntStartInf!: ButtonAPI;
  @Inject(StartEndAdmChemoAliases.BUTTON_STARTADM_REMOVE)
  private bntStartRem!: ButtonAPI;
  @Inject(StartEndAdmChemoAliases.BUTTON_ENDADM_REMOVE)
  private bntEndRem!: ButtonAPI;
  @Inject(StartEndAdmChemoAliases.BUTTON_ENDADM_INFORMATION)
  private bntEndInfo!: ButtonAPI;
  @Inject(StartEndAdmChemoAliases.CONTEXTUAL_BAR_ARRIVED)
  private contextualBarApi!: ContextualBarAPI;

  @OnClick(StartEndAdmChemoAliases.BUTTON_ARRIVED_INFORMATION)
  async handleClickButtonRelease(): Promise<void> {
    const canArrivedAttend = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.ALLOWS_REGISTER_PATIENT_ARRIVAL_WITHOUT_LINKING_SERVICE);
    const canArrivedPrescr = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.ALLOWS_GENERATE_PATIENT_ARRIVAL_WITHOUT_PRESCRIPTION);

    const { encounterId, prescriptionId, sequenceId } = this.historyService.getCurrentRouteParams();

    if ((canArrivedPrescr == ValueParams.NO && !prescriptionId) || (canArrivedAttend == ValueParams.NO && !encounterId)) {
      const msg = MessageService.translate('tws.error-generic');
      const titleMessage = MessageService.translate('text.message-alert-attention');
      this.errorMessage(msg, titleMessage);
      return;
    }

    const ret = await HttpService.get(Endpoint.CHEMO_SET_DATE_ARRIVED, { sequenceId });
    if (ret) {
      const msg = MessageService.translate('text.perform-with-success');
      this.okMessage(msg);
      this.inputArrived.setValue(new Date().toISOString());
      if (this.information) {
        this.information.body.dtArrived = new Date().toISOString();
      }
      this.callValidateAll();
    }
  }

  @OnClick(StartEndAdmChemoAliases.BUTTON_STARTADM_REMOVE)
  async handleClickButtonUndoAdm(): Promise<void> {
    const { sequenceId } = this.historyService.getCurrentRouteParams();
    const seqEncounterId = sequenceId;
    const ret = await HttpService.post(Endpoint.CHEMO_UNDO_START_ADM, { seqEncounterId });
    const error = ret.body as Record<string, Value>;

    if (error.ds_erro_p) {
      this.dialogModalConfirm('dialog-modal-service8', ret.body as string, true, () => { ModalService.close('dialog-modal-service8'); });
    }else{
      this.inputStart.setValue('');
      if (this.information) {
        this.information.body.dtStartAdm = '';
      }
      this.callValidateAll();
      this.okMessage(MessageService.translate('text.perform-with-success'));
    }

  }

  validEndAdmButtonInfEnabled(): void {
    const dtStartAdm = this.information?.body.dtStartAdm;
    const dtEndAdm = this.information?.body.dtEndAdm;
    this.bntEndInfo.setEnabled(!this.isNullOrEmpty(dtStartAdm) && this.isNullOrEmpty(dtEndAdm));
  }

  validEndAdmButtonRemEnabled(): void {
    const dtEndAdm = this.information?.body.dtEndAdm;
    this.bntEndRem.setEnabled(!this.isNullOrEmpty(dtEndAdm));
  }

  callValidateAll(): void {
    this.validaEnableInputArrived();
    this.validaEnableAcomodation();
    this.validRemoveArriveButtonEnabled();
    this.validStartAdmButtonRemEnabled();
    this.validStartAdmButtonInfEnabled();
    this.validEndAdmButtonInfEnabled();
    this.validEndAdmButtonRemEnabled();
  }

  private isNullOrEmpty(value: string | null | undefined | number | unknown[]): boolean {
    return value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0);
  }

  @OnClick(StartEndAdmChemoAliases.BUTTON_ARRIVE_REMOVE)
  async handleClickButtonRemove(): Promise<void> {
    const { sequenceId } = this.historyService.getCurrentRouteParams();

    const ret = await HttpService.get(Endpoint.CHEMO_REMOVE_DATE_ARRIVED, { sequenceId });
    if (ret) {
      const msg = MessageService.translate('text.perform-with-success');
      this.okMessage(msg);
      this.inputArrived.setValue('');
      if (this.information) {
        this.information.body.dtArrived = '';
      }
      this.callValidateAll();
    }
  }

  @OnClick(StartEndAdmChemoAliases.BUTTON_STARTADM_INFORMATION)
  async handleClickStartButtonInf(): Promise<void> {
    const param290 = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.CONSIST_WHETHER_ORDER_WAIVED_WHEN_ADMINISTRATION_BEGAN);

    if (param290 == ValueParams.ALERT || param290 == ValueParams.YES) {
      if (this.information?.body.ieOrdemDisp == ValueParams.NO) {
        if (param290 == ValueParams.YES) {
          const id = 'dialog-modal-service1';
          this.dialogModalConfirm(id, this.information.body.dsErro, true, () => { ModalService.close(id); });
          return;
        }
        const id = 'dialog-modal-service2';
        this.dialogModalConfirm(id, this.information.body.dsQuestion, false, () => { ModalService.close(id); this.verifyMsgAlert(); });
        return;
      }
    }
    this.continueStartAdm();
  }

  @OnClick(StartEndAdmChemoAliases.BUTTON_ENDADM_INFORMATION)
  async handleClickEndButtonInf(): Promise<void> {
    this.startProcessEndAdm();
  }

  @OnClick(StartEndAdmChemoAliases.BUTTON_ENDADM_REMOVE)
  async handleClickEndButtonRem(): Promise<void> {
    this.callprocFinalizarADM('D');
  }

  verifyMsgAlert(): void {
    if (this.information?.body.dsMsgAlerta) {
      const id = 'dialog-modal-service3';
      this.dialogModalConfirm(id, this.information.body.dsMsgAlerta, true, () => { ModalService.close(id); this.continueStartAdm(); });
    }
  }

  async continueStartAdm(): Promise<void> {

    if (this.information?.body.param123 == ValueParams.YES && this.information?.body.nrSeqScheduler > 0) {
      const seqSchedulerId = this.information?.body.nrSeqScheduler;
      await HttpService.post(Endpoint.CHEMO_SET_SCHEDULER, { seqSchedulerId });
    }
    const param338 = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.REQUEST_DATE_WHEN_RECORDING_START_ADMINISTRATION);

    if (param338 == ValueParams.YES) {
      this.dialogModalFragment(true);
    } else {
      this.atualizaInicioADM(moment());
    }
  }

  updateTimeToCurrent(momentObj: moment.Moment, hor: string): moment.Moment {
    const time = hor.split(':');
    return momentObj.hour(parseInt(time[0])).minute(parseInt(time[1])).add(momentObj.utcOffset(), 'minute');
  }

  private async dialogModalConfirm(id: string, msg: string, isConfirm: boolean, event: () => void): Promise<void> {
    const buttons: ModalButton[] = [];

    if (isConfirm) {
      buttons.push({
        action: event,
        title: 'tws.file-uploader-modal.confirm',
        type: ModalButtonType.SUCCESS,
      });
    } else {
      buttons.push({
        action: () => ModalService.close(id),
        title: 'tws.biometry.cancel',
        type: ModalButtonType.CANCEL,
      });

      buttons.push({
        action: event,
        title: 'tws.file-uploader-modal.confirm',
        type: ModalButtonType.SUCCESS,
      });
    }

    const dialogModal: BaseModalProps = {
      dialogDescription: msg,
      dockButtons: buttons,
      focusOnOpen: true,
      id: id,
      title: 'text.message-alert-attention',
    };

    ModalService.openDialog(dialogModal);
  }

  private dialogModalFragment(isStart: boolean): void {
    const onModalSubmit = (event: SubmitEvent): void => {
      const dateValue = this.updateTimeToCurrent(moment(event.record.dataStart), event.record.dataHor as string);
      ModalService.close(FragmentNames.CHEMO_START_ADM);
      if (isStart) {
        this.atualizaInicioADM(dateValue);
      } else {
        this.informEndADM(dateValue);
        this.callValidateAll();
        this.finishedProcessEndAdm();
      }
    };
    let title = MessageService.translate('text.date-ent-adm-title');
    if (isStart) {
      title = MessageService.translate('text.start-date-adm');
    }

    const dialogModal: BaseModalProps = {
      contextData: {
        isStart: isStart
      },
      focusOnOpen: true,
      fragment: FragmentNames.CHEMO_START_ADM,
      id: FragmentNames.CHEMO_START_ADM,
      onCancel: () => ModalService.close(FragmentNames.CHEMO_START_ADM),
      onSubmit: onModalSubmit,
      title: title,
      type: ModalType.DEFAULT,
    };

    ModalService.openDefault(dialogModal);
  }

  async atualizaInicioADM(dateAdm: Moment): Promise<void> {
    const { sequenceId } = this.historyService.getCurrentRouteParams();
    const seqEncounterId = sequenceId;

    const body = {
      dateAdm: dateAdm
    } as Record<string, Value>;

    await HttpService.post(Endpoint.CHEMO_UPDATE_STARTADM, { seqEncounterId }, { body });
    this.inputStart.setValue(dateAdm.toISOString());
    if (this.information?.body) {
      this.information.body.dtStartAdm = dateAdm.toISOString();
    }
    this.callValidateAll();
    this.checkParameter31();
  }

  changeStatusAgeXame(): void {
    const param276 = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.STATUS_CHANGING_EXAM_SCHEDULE_WHEN_USING_HOME_ADMINISTRATION_OPTION);
    const param275 = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.EXAM_SCHEDULE_CODES_CHANGING_STATUSES);
    const param277 = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.STATUS_CHANGING_EXAM_SCHEDULE_WHEN_USING_END_ADMINISTRATION_OPTION);

    if ((!this.isNullOrEmpty(param276) || !this.isNullOrEmpty(param277)) && !this.isNullOrEmpty(param275)) {
      const body = {
        dtScheduler: moment()
      } as Record<string, Value>;

      const seqPatientId = this.information?.body.nrPatient;
      HttpService.post(Endpoint.CHEMO_UPDATE_STATUS_AGENDA,
        { seqPatientId }, { body });

    }

  }

  checkParameter31(): void {
    const param31 = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.ALLOW_RECORDING_START_END_ADMINISTRATION_SAME_TIME);

    if (param31 == ValueParams.YES) {
      this.startProcessEndAdm();
    } else {
      this.changeStatusAgeXame();
      this.okMessage(MessageService.translate('text.perform-with-success'));
    }
  }

  @OnBeforeFetch({ target: StartEndAdmChemoAliases.ACOMODATION_FETCH })
  onBeforeFetchDepartment(evt: FetchEvent): void {
    const event = evt.target as FetchAPI;
    const { encounterId } = this.historyService.getCurrentRouteParams();

    this.context.set({
      encounterId
    });
    if (evt) {
      const params = {
        nrAtendimento: encounterId as string,
      }

      event.setParameters(params);
    }
  }

  validaEnableInputArrived(): void {
    const canDateActual = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.ALLOWS_YOU_USE_PATIENT_ARRIVAL_OPTION_ONLY_ACTUAL_DATE);
    const dtCampoTruncated = this.getTruncatedDate(String(this.information?.body.dtArrived));
    const dtReal = this.information?.body.dtReal ? this.getTruncatedDate(this.information.body.dtReal) : null;
    this.bntArrivedInf.setEnabled(this.isNullOrEmpty(this.information?.body.dtArrived) &&
      (canDateActual === ValueParams.NO || dtReal == dtCampoTruncated));
  }

  getTruncatedDate(campo: string): string | null {
    const inputArrivedValue = campo;
    if (inputArrivedValue) {
      const truncatedDate = moment(inputArrivedValue).startOf('day').format('YYYY-MM-DD');
      return truncatedDate;
    }
    return null;
  }

  validRemoveArriveButtonEnabled(): void {
    const dtArrived = this.information?.body.dtArrived;
    const dtIniAdm = this.information?.body.dtStartAdm;
    const autoCompleteValue = this.information?.body.cdLocal;
    this.bntArrivedRem.setEnabled(!this.isNullOrEmpty(dtArrived) &&
      this.isNullOrEmpty(dtIniAdm) && (autoCompleteValue == null || autoCompleteValue == 0));
  }

  validStartAdmButtonInfEnabled(): void {
    const canStartAdm = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.ALLOW_RECORDING_START_MEDICATION_ADMINISTRATION);
    const startAdmWithOutAcomo = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.ALLOW_MEDICATION_ADMINISTRATION_BEGIN_WITHOUT_DEFINING_ACCOMMODATION);
    const startAdmWithOutRelease = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.ALLOWS_USE_START_ADMINISTRATION_OPTION_WITHOUT_RELEASING_MEDICATION);
    let isEnable = true;
    const dtArrived = this.information?.body.dtArrived;
    const dtStartAdm = this.information?.body.dtStartAdm;

    const infoBody = this.information?.body;

    if (canStartAdm != ValueParams.YES) {
      isEnable = false;
    }

    if (this.isNullOrEmpty(infoBody?.nrPrescription)) {
      isEnable = false;
    }

    if (!this.isNullOrEmpty(dtStartAdm)) {
      isEnable = false;
    }

    if (this.isNullOrEmpty(dtArrived) && infoBody?.dsTypeEncount != ValueParams.YES) {
      isEnable = false;
    }

    const autoCompleteValue = this.information?.body.cdLocal;

    if (startAdmWithOutAcomo != ValueParams.YES || autoCompleteValue == null || autoCompleteValue == 0) {
      if (startAdmWithOutAcomo != 'I' || infoBody?.dsTypeEncount != ValueParams.YES) {
        isEnable = false;
      }
    }

    if (startAdmWithOutRelease != ValueParams.YES && infoBody?.nrPrescrEncount != ValueParams.YES) {
      isEnable = false;
    }
    this.bntStartInf.setEnabled(isEnable);
  }

  validStartAdmButtonRemEnabled(): void {
    const dtStartAdm = this.information?.body.dtStartAdm;
    const dtEndAdm = this.information?.body.dtEndAdm;
    this.bntStartRem.setEnabled(!this.isNullOrEmpty(dtStartAdm) &&
      this.isNullOrEmpty(dtEndAdm));
  }

  validaEnableAcomodation(): void {
    const canArrivedAttend = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.WHEN_DEFINING_ACCOMMODATION_REGISTER_PATIENT_ARRIVAL);

    const autoCompleteValue = this.information?.body.cdLocal;
    const inputArrivedValue = this.information?.body.dtArrived;
    this.autoCompleteAcomodation.setEnabled((autoCompleteValue != null && !this.isNullOrEmpty(autoCompleteValue))
    || ((!this.isNullOrEmpty(inputArrivedValue) || canArrivedAttend === ValueParams.YES)
      && this.isNullOrEmpty(this.information?.body.dtEndAdm)
      && (this.information?.body.ieReleaseDemands === ValueParams.NO ||
        (this.information?.body.ieReleaseDemands === ValueParams.YES && !this.isNullOrEmpty(this.information?.body.dtRelease)))
      && this.isNullOrEmpty(this.information?.body.dtDischarge)));
  }

  @OnChange({ target: StartEndAdmChemoAliases.ACOMODATION_AUTOCOMPLETE })
  async handleChangeAcomodationnput(evt: ChangeEvent<AutocompleteAPI>): Promise<void> {

    if (evt.prettyValue || evt.prettyValue === '') {
      const seqPatientId = this.information?.body.nrPatient;
      const { sequenceId } = this.historyService.getCurrentRouteParams();
      const seqEncounterId = sequenceId;
      const valorAcomodation = evt.value as unknown as AutoCompAcomodation || null
      const cdAcomodId = valorAcomodation ? valorAcomodation.cdAcomodacao : 0;
      const dtPrev = this.information?.body.dtPrev;
      const dtReal = this.information?.body.dtReal;

      const body = {
        cdAcomodId: cdAcomodId,
        dtPrevista: dtPrev,
        dtReal: dtReal
      } as Record<string, Value>;

      const ret = await HttpService.post(Endpoint.CHEMO_SET_ACOMODATION,
        { seqEncounterId, seqPatientId }, { body });
      const msg = ret.body as RetornoProc;

      if (!this.isNullOrEmpty(msg.dsErro) || !this.isNullOrEmpty(msg.dsMsg)) {
        this.errorMessage(msg.dsMsg, msg.dsErro);
        return;
      }
      this.okMessage(MessageService.translate('text.perform-with-success'));
      if (this.information && typeof cdAcomodId === 'number') {
        this.information.body.cdLocal = cdAcomodId;
      }
      this.callValidateAll();
    }

  }

  setEnableAllinput(): void {
    this.inputArrived.setEnabled(false);
    this.inputEnd.setEnabled(false);
    this.inputStart.setEnabled(false);
  }

  @OnMount(StartEndAdmChemoAliases.MAIN_LAYOUT)
  async onMountLayoutMain(): Promise<void> {
    InformationBarUtils.collapsedBar = true;
    const { patientId, encounterId, sequenceId } = this.historyService.getCurrentRouteParams();

    this.context.set({ encounterId, patientId });

    if (sequenceId as number <= 0) {
      return;
    }

    this.setEnableAllinput();

    const informationProtocol = await HttpService.get(Endpoint.CHEMO_INFORMATION_PROTOCOL, {encounterId, sequenceId});
    this.information = informationProtocol as InformationProtocol;
    const body = this.information?.body;

    if (body) {
      this.setInputValue(body.dtArrived, this.inputArrived);
      this.setInputValue(body.dtEndAdm, this.inputEnd);
      this.setInputValue(body.dtStartAdm, this.inputStart);

      if (body.dsTitle) {
        this.contextualBarApi.setTitle(body.dsTitle);
      }
      if (body.cdLocal && this.autoCompleteAcomodation) {
        this.autoCompleteAcomodation.setValue({ cdAcomodacao: body.cdLocal, dsAcomodacao: body.dsLocal });
      }
      this.callValidateAll();
    }
  }

  private setInputValue(value: string | undefined, input: InputAPI): void {
    if (value) {
      input.setValue(value);
    }
  }

  okMessage(msg: string): void {
    ToastService.close('custom-toast');
    ToastService.open({
      dismissible: true,
      id: 'custom-toast',
      level: ToastLevel.SUCCESS,
      message: msg,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
    });
  }

  errorMessage(msg: string, titulo: string): void {
    ToastService.close('custom-toast');
    ToastService.open({
      dismissible: true,
      id: 'custom-toast',
      level: ToastLevel.ERROR,
      message: msg,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      title: titulo,
    });
  }

  async startProcessEndAdm(): Promise<void> {
    const { encounterId } = this.historyService.getCurrentRouteParams();
    const param381 = FoundationUtils.findModuleParam(FunctionName.CHEMO_3130, CHEMO_E3130Parameters.ALLOW_COMPLETION_ADMINISTRATION_ONLY_IF_ALL_PATIENT_ORDERS_DISPENSED_WITH);

    if (encounterId != null && param381 == ValueParams.YES) {
      if (this.information?.body.ieEnconterDisp == ValueParams.NO) {
        const msg = MessageService.translate('text.end-disp-all-order');
        const titleMessage = MessageService.translate('text.message-alert-attention');
        this.errorMessage(msg, titleMessage);
        return;
      }
    }

    this.validateCheckedItens();
  }

  askForEndWithUncheckedItems(): void {
    const id = 'dialog-modal-service4';
    const msg = MessageService.translate('text.there-are-medic-without-check');
    this.dialogModalConfirm(id, msg, true, () => { ModalService.close(id); this.continueProcessEndAdm(); });
  }

  async continueProcessEndAdm(): Promise<void> {
    const param296 = FoundationUtils.findModuleParam(FunctionName.CHEMO_3130, CHEMO_E3130Parameters.REQUEST_DATE_WHEN_RECORDING_END_ADMINISTRATION);

    if (param296 == ValueParams.YES) {
      this.dialogModalFragment(false);
    }
    else {
      this.finishedProcessEndAdm();
    }
  }

  async finishedProcessEndAdm(): Promise<void> {

    const param296 = FoundationUtils.findModuleParam(FunctionName.CHEMO_3130, CHEMO_E3130Parameters.REQUEST_DATE_WHEN_RECORDING_END_ADMINISTRATION);
    if (param296 == 'N') {
      this.inputEnd.setValue(moment().toISOString());
      if (this.information) {
        this.information.body.dtEndAdm = moment().toISOString();
      }
      this.callValidateAll();
      await this.informEndADM(moment());
    }

    const ret = await this.callprocFinalizarADM('F');
    if (ret.ds_alerta_p) {
      const id = 'dialog-modal-service5';
      this.dialogModalConfirm(id, ret.ds_alerta_p as string, true, () => { ModalService.close(id); this.startProcessAlta(false); });
    }
  }

  async startProcessAlta(validQuestion: boolean): Promise<void> {
    const param115 = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.REASON_STANDARD_DISCHARGE_END_MEDICATION_ADMINISTRATION);
    const param223 = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.WHEN_DISCHARGED_CHECK_WHETHER_TYPE_CARE_OUTPATIENT);

    if (param115 as number > 0 && (param223 == ValueParams.NO || this.information?.body.ieTypeEnconter == 8)) {
      if (!validQuestion) {
        this.dialogModalConfirm('dialog-modal-service6', MessageService.translate('text.question-patient-discharge'), false,
          () => { ModalService.close('dialog-modal-service6'); this.startProcessAlta(true); });
      } else {
        const { encounterId } = this.historyService.getCurrentRouteParams();
        const ret = await HttpService.post(Endpoint.CHEMO_GERAR_ESTORNAR_ALTA, { encounterId });
        const error = ret.body as Record<string, Value>;

        if (error.ds_erro_p) {
          const id = 'dialog-modal-service7';
          this.dialogModalConfirm(id, error.ds_alerta_p as string, true, () => { ModalService.close(id); });
        }
        this.changeStatusAgeXame();
      }
    }

  }

  async callprocFinalizarADM(ieType: string): Promise<Record<string, Value>> {
    const nrPrescriptionId = this.information?.body.nrPrescription;
    const { encounterId, sequenceId } = this.historyService.getCurrentRouteParams();
    const seqEncounterId = sequenceId;
    const dtPrev = this.information?.body.dtPrev;
    const dtReal = this.information?.body.dtReal;

    const body = {
      cdAcomodId: 0,
      dtPrevista: dtPrev,
      dtReal: dtReal,
      ieType: ieType
    } as Record<string, Value>;

    const ret = await HttpService.post(Endpoint.CHEMO_FINALIZE_ADM,
      { encounterId, nrPrescriptionId, seqEncounterId }, { body });

    if (ieType == 'D') {
      this.inputEnd.setValue('');
      if (this.information) {
        this.information.body.dtEndAdm = '';
        this.callValidateAll();
        this.okMessage(MessageService.translate('text.perform-with-success'));
      }
    }

    return ret.body as Record<string, Value>;
  }

  validateCheckedItens(): void {
    const param45 = FoundationUtils.findModuleParam(
      FunctionName.CHEMO_3130, CHEMO_E3130Parameters.AT_END_ADMINISTRATION_CHECK_MEDICATIONS);

    if (param45 != ValueParams.YES) {
      this.continueProcessEndAdm();
      return;
    }

    if (this.information?.body.ieQtCheck == 0) {
      this.continueProcessEndAdm();
      return;
    }

    this.askForEndWithUncheckedItems();
  }

  async informEndADM(dateAdm: Moment): Promise<void> {
    const { sequenceId } = this.historyService.getCurrentRouteParams();
    const seqEncounterId = sequenceId;

    const body = {
      dateAdm: dateAdm
    } as Record<string, Value>;

    await HttpService.post(Endpoint.CHEMO_UPDATE_ENDADM, { seqEncounterId }, { body });
    this.inputEnd.setValue(dateAdm.toISOString());
    if (this.information) {
      this.information.body.dtEndAdm = dateAdm.toISOString();
      this.callValidateAll();
    }
    this.okMessage(MessageService.translate('text.perform-with-success'));
  }

}

export default StartEndAdmChemoController;
